import * as api from "@/api";
import { getListing } from "@lab/api/listings.api";
import makeListingMixin from "@lab/store/vuexListingMixin";
import { FacilityFields } from "@/forms/Facility/fields";

export const PLAN_BASIC = "Basic";
export const PLAN_TRIAL = "Trial";
export const PLAN_SUBSCRIPTION_LEVEL_1 = "Subscription level 1";
export const PLAN_SUBSCRIPTION_LEVEL_2 = "Subscription level 2";
export const PLAN_SUBSCRIPTION_LEVEL_3 = "Subscription level 3";

// Clean up a listing object before sending to the API for update
// - due to baffling decisions in the formMixin, initial values for fields are [] instead of null
//   which causes issues when fields should be null so we reset them here
function cleanListingForUpdate(listing) {
	const cleanedListing = { ...listing };

	if (Array.isArray(cleanedListing.onlineenquiriesuserid)) {
		cleanedListing.onlineenquiriesuserid = null;
	}

	return cleanedListing;
}

export default makeListingMixin(
	"listing",
	api.listings
)({
	state: {
		fields: FacilityFields,
	},
	mutations: {
		changeStatus(state, { id, status }) {
			state.byID[id].status = status;
		},
		listingUpdateImages(state, { id, images }) {
			state.byID[id].images = images;
		},
		listingUpdateMedia(state, { id, brochures }) {
			brochures.forEach((brochure) => (brochure.status = "active"));
			state.byID[id].brochures = brochures;
		},
	},
	actions: {
		async listingUpdate(context, listing) {
			listing = cleanListingForUpdate(listing);
			try {
				const _listing = await api.listings("PUT", listing);
				context.commit("listingUpdateSuccess", _listing);

				// we only want to run the media query if there something to sent
				if (listing.images) {
					await api.listingUpdateMedia(
						listing.id,
						"mediaimages",
						listing.images
					);
					context.commit("listingUpdateImages", listing);
				}
				if (listing.brochures) {
					await api.listingUpdateMedia(
						listing.id,
						"mediapdfs",
						listing.brochures
					);
					context.commit("listingUpdateMedia", listing);
				}
			} catch (error) {
				// Just rethrowing error for the moment.
				console.log(error);
				throw error;
			}
		},
		async listingRefresh({ commit }, listing) {
			const { id } = listing;
			const _listing = await getListing(id);

			commit("listingUpdateSuccess", _listing);
		},
		async listingPublish(context, listing) {
			const id = listing.id;
			const status = "active";
			context.commit(`changeStatus`, {
				id,
				status,
			});
			try {
				await api.listings("PUT", listing);
				context.commit("listingUpdateSuccess", listing);
			} catch (error) {
				console.log(error);
				throw error;
			}
		},
		async listingUnPublish(context, listing) {
			const id = listing.id;
			const status = "non-active";
			context.commit(`changeStatus`, {
				id,
				status,
			});
			try {
				await api.listings("PUT", listing);
				context.commit("listingUpdateSuccess", listing);
			} catch (error) {
				console.log(error);
				throw error;
			}
		},
	},
	getters: {
		listingIsSRS: (state, getters) => (listingID) => {
			const listing = getters.listingGet(listingID);
			if (!listing) return false;
			return listing.category === "SRS/SRF";
		},
		listingItemForm: (state) => (name) => {
			return state.fields.find((field) => field.name === name);
		},
	},
});
